/* PerfectBaby — pb-pdp-tabs.js · v15 · 2026-07-23
   Kaching containment, zero-jump edition.
   The buy-wrap (#pb-pg-buywrap) now renders for EVERY product and is
   height-capped to 0 while inside the product pane (section CSS), so
   Kaching hydrates invisibly — no layout shift, no flash (their gate is
   the [type=submit] anchor, not visibility — found empirically).
   This script: (1) clears leftover track transform, (2) when Kaching
   content appears inside the buy-wrap → moves the wrap into the Bundles
   pane (cap no longer applies there) and reveals the tabs, (3) keeps
   pane visibility synced with the active tab. No deal → nothing shows.
   The section sets Bundles as the default; only an explicit shopper choice opens Product only. */
(function () {
  'use strict';

  var track = document.getElementById('pb-pg-track');
  if (track) { track.style.transform = ''; }

  var wrap = document.getElementById('pb-pg-buywrap');
  var tabs = document.getElementById('pb-pg-tabs');
  var paneB = document.getElementById('pb-pg-pane-bundle');
  var paneP = document.getElementById('pb-pg-pane-product');
  if (!wrap || !tabs || !paneB || !paneP) return;

  var settled = false;
  var layoutObserver = null;

  function keepSelectedOffer(event) {
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    var target = event.target;
    if (!target || !target.closest) return;
    var heading = target.closest('.kaching-bundles__bar-main');
    if (!heading || !wrap.contains(heading)) return;
    if (target.closest('a, button, select, input, textarea')) return;
    var bar = heading.closest('.kaching-bundles__bar');
    var radio = bar && bar.querySelector('input[type="radio"]');
    if (!bar || !bar.classList.contains('kaching-bundles__bar--selected') || !radio || !radio.checked) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  wrap.addEventListener('click', keepSelectedOffer, true);
  wrap.addEventListener('keydown', keepSelectedOffer, true);

  function hasKaching() {
    return !!wrap.querySelector('.kaching-bundles__bar');
  }

  function activeIsBundle() {
    var t = tabs.querySelector('.pb-pg__tab.is-on');
    return !!(t && t.getAttribute('data-pb-pane') === 'bundle');
  }

  function placeBundleCta() {
    wrap.querySelectorAll('.kaching-bundles__bundle-products__product').forEach(function (product) {
      var links = product.querySelectorAll('a.kaching-bundles__bundle-products__link');
      links.forEach(function (link) {
        if (link.textContent.trim() || (link.hasAttribute('aria-label') && !link.hasAttribute('data-pb-image-label'))) return;
        var titleLink = Array.prototype.find.call(links, function (candidate) {
          return candidate.href === link.href && candidate.textContent.trim();
        });
        if (!titleLink) return;
        var label = titleLink.textContent.trim();
        if (link.getAttribute('aria-label') !== label) link.setAttribute('aria-label', label);
        link.setAttribute('data-pb-image-label', 'true');
      });
    });
    var selected = wrap.querySelector('.kaching-bundles__bar--selected');
    var ctaTrack = wrap.querySelector('.pbk-cta-track');
    if (!selected || !ctaTrack || !selected.parentNode) return;
    var ctaButton = ctaTrack.querySelector('.pb-pg__bundle-atc');
    if (ctaButton) ctaButton.setAttribute('form', 'pb-pg-form');
    if (selected.nextElementSibling !== ctaTrack) {
      selected.parentNode.insertBefore(ctaTrack, selected.nextElementSibling);
    }
  }

  function sync() {
    if (!settled) return;
    var b = activeIsBundle();
    if (paneB.hidden !== !b) paneB.hidden = !b;
    if (paneP.hidden !== b) paneP.hidden = b;
    var root = document.querySelector('.pb-pg');
    if (root) root.classList.toggle('pb-pg--bundle-on', b);
    if (b) placeBundleCta();
  }

  function settle() {
    if (settled) return;
    settled = true;
    paneB.appendChild(wrap);
    tabs.hidden = false;
    var tabEls = tabs.querySelectorAll('.pb-pg__tab');
    var params = new URLSearchParams(window.location.search);
    var bundleParam = params.get('pb_bundle');
    var requestedPane = tabs.getAttribute('data-pb-default-pane') === 'bundle' ? 'bundle' : 'product';
    if (bundleParam === '1') requestedPane = 'bundle';
    if (bundleParam === '0' || (bundleParam === null && params.get('pb_tab') === 'product')) requestedPane = 'product';
    for (var i = 0; i < tabEls.length; i++) {
      var selected = tabEls[i].getAttribute('data-pb-pane') === requestedPane;
      tabEls[i].classList.toggle('is-on', selected);
      tabEls[i].setAttribute('aria-pressed', selected ? 'true' : 'false');
    }
    sync();
    if (!layoutObserver) {
      layoutObserver = new MutationObserver(placeBundleCta);
      layoutObserver.observe(wrap, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  function check() {
    if (!settled && hasKaching()) { settle(); }
  }

  var mo = new MutationObserver(check);
  mo.observe(wrap, { childList: true, subtree: true });
  [400, 900, 1800, 3200, 5000, 8000].forEach(function (ms) { setTimeout(check, ms); });

  setTimeout(function () {
    mo.disconnect();
    if (settled) {
      var mo2 = new MutationObserver(sync);
      mo2.observe(paneB, { attributes: true, attributeFilter: ['hidden'] });
      mo2.observe(paneP, { attributes: true, attributeFilter: ['hidden'] });
    }
  }, 12000);

  tabs.addEventListener('click', function (event) {
    setTimeout(sync, 0);
    if (!event.isTrusted) return;
    var tab = event.target.closest('.pb-pg__tab');
    if (!tab) return;
    var pane = tab.getAttribute('data-pb-pane');
    if (pane !== 'product' && pane !== 'bundle') return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('pb_bundle', pane === 'bundle' ? '1' : '0');
      if (pane === 'bundle' && tab.hasAttribute('data-pbfm-bar')) {
        var setTabs = tabs.querySelectorAll('[data-pbfm-bar]');
        for (var i = 0; i < setTabs.length; i++) {
          if (setTabs[i] === tab) url.searchParams.set('set', String(i + 1));
        }
      }
      window.history.replaceState(window.history.state, '', url.href);
    } catch (error) {}
  });
})();

/* 2026-10-08: expose the native single-lounger add-on after an explicit Product only choice.
   Kaching still owns selection, availability, pricing and cart submission. Accepting this
   optional offer opens its two-item selection for review; it never adds to cart itself. */
(function () {
  'use strict';
  var root = document.querySelector('.pb-pg');
  var tabs = document.getElementById('pb-pg-tabs');
  var productPane = document.getElementById('pb-pg-pane-product');
  var wrap = document.getElementById('pb-pg-buywrap');
  var quantity = document.getElementById('pb-pg-qty');
  if (!root || !tabs || !productPane || !wrap || !quantity) return;
  var blockSelector = '[data-deal-block-id="bf55cb8f-7346-41c7-bd76-f73422bc2a2d"][data-ab-test-variant="B"]';
  var singleSelector = '[data-deal-bar-id="8rkQ"]';
  var button, wasProduct = false, restoreBar = '', accepting = false, disposed = false;
  var timer = null, acceptTimer = null;

  function selectBar(bar) {
    if (!bar || bar.classList.contains('kaching-bundles__bar--selected')) return;
    var heading = bar.querySelector('.kaching-bundles__bar-main');
    if (heading) heading.click();
  }
  function refresh() {
    if (disposed || tabs.hidden) return;
    var block = wrap.querySelector(blockSelector);
    var single = block && block.querySelector(singleSelector);
    if (!single) { if (button) button.hidden = true; return; }
    var active = tabs.querySelector('.pb-pg__tab.is-on');
    var isProduct = !!active && active.getAttribute('data-pb-pane') === 'product';
    if (isProduct && !wasProduct) {
      var selected = block.querySelector('.kaching-bundles__bar--selected');
      restoreBar = selected ? selected.getAttribute('data-deal-bar-id') : '';
      wasProduct = true;
      selectBar(single);
    } else if (!isProduct && wasProduct) {
      wasProduct = false;
      if (!accepting && restoreBar) {
        var previous = Array.from(block.querySelectorAll('.kaching-bundles__bar')).find(function (bar) {
          return bar.getAttribute('data-deal-bar-id') === restoreBar;
        });
        selectBar(previous);
      }
      accepting = false;
    }
    var upsell = single.querySelector('.kaching-bundles__upsell');
    var label = upsell && upsell.querySelector('.kaching-bundles__upsell__text');
    var price = upsell && upsell.querySelector('.kaching-bundles__upsell__price');
    var image = upsell && upsell.querySelector('img');
    var variant = window.PBPurchase && window.PBPurchase.variant();
    var available = isProduct && label && price && variant && variant.available && Number(quantity.value) === 1;
    if (!available) { if (button) button.hidden = true; return; }
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'pb-pg__single-extra';
      button.setAttribute('aria-controls', 'pb-pg-pane-bundle');
      button.innerHTML = '<img alt="" width="48" height="48"><span></span><strong></strong>';
      productPane.appendChild(button);
      button.addEventListener('click', accept);
    }
    var symbol = (document.getElementById('pb-pg-cta-price').textContent.match(/[€$£¥]/) || [''])[0];
    var amount = price.textContent.trim();
    if (!/[€$£¥]/.test(amount)) amount = symbol + amount;
    var text = label.textContent.trim();
    if (button.querySelector('span').textContent !== text) button.querySelector('span').textContent = text;
    if (button.querySelector('strong').textContent !== amount) button.querySelector('strong').textContent = amount;
    var picture = button.querySelector('img');
    if (image && picture.getAttribute('src') !== image.getAttribute('src')) picture.setAttribute('src', image.getAttribute('src'));
    picture.hidden = !image;
    button.disabled = root.getAttribute('aria-busy') === 'true';
    button.hidden = false;
  }
  function accept() {
    if (disposed || root.getAttribute('aria-busy') === 'true' || Number(quantity.value) !== 1) return;
    var block = wrap.querySelector(blockSelector);
    var single = block && block.querySelector(singleSelector);
    var variant = window.PBPurchase && window.PBPurchase.variant();
    var tab = tabs.querySelector('[data-pb-pane="bundle"]');
    if (!single || !variant || !variant.available || !tab) return;
    accepting = true;
    selectBar(single);
    tab.click();
    var destination = new URL(location.href);
    destination.searchParams.set('pb_bundle', '1');
    history.replaceState(history.state, '', destination.href);
    clearTimeout(acceptTimer);
    acceptTimer = setTimeout(function () {
      if (disposed || !root.classList.contains('pb-pg--bundle-on')) return;
      var current = wrap.querySelector(blockSelector + ' ' + singleSelector);
      if (!current || !current.classList.contains('kaching-bundles__bar--selected')) return;
      var selects = current.querySelectorAll('.kaching-bundles__collection-product select');
      Array.from(selects).forEach(function (select, i) {
        var value = variant.options[i];
        if (value && select.value !== value && Array.from(select.options).some(function (option) { return option.value === value && !option.disabled; })) {
          select.value = value;
          select.dispatchEvent(new Event('change', {bubbles: true}));
        }
      });
      var toggle = current.querySelector('.kaching-bundles__upsell__checkbox');
      if (toggle && !toggle.classList.contains('kaching-bundles__upsell__checkbox--selected')) toggle.click();
      if (toggle) { toggle.focus({preventScroll: true}); current.scrollIntoView({block: 'center', behavior: 'auto'}); }
    }, 200);
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 50); }
  var observer = new MutationObserver(schedule);
  observer.observe(wrap, {childList: true, subtree: true});
  observer.observe(productPane, {attributes: true, attributeFilter: ['hidden']});
  observer.observe(tabs, {attributes: true, attributeFilter: ['hidden']});
  observer.observe(root, {attributes: true, attributeFilter: ['aria-busy']});
  quantity.addEventListener('input', schedule);
  root.addEventListener('click', schedule);
  document.addEventListener('pb:variant-change', schedule);
  function dispose(event) {
    if (event.target !== root && !(event.target && event.target.contains && event.target.contains(root))) return;
    disposed = true; observer.disconnect(); clearTimeout(timer); clearTimeout(acceptTimer);
    quantity.removeEventListener('input', schedule); root.removeEventListener('click', schedule);
    document.removeEventListener('pb:variant-change', schedule);
    document.removeEventListener('shopify:section:unload', dispose);
  }
  document.addEventListener('shopify:section:unload', dispose);
  var style = document.createElement('style');
  style.textContent = '.pb-pg__single-extra{display:grid;grid-template-columns:48px minmax(0,1fr) auto;align-items:center;gap:10px;width:100%;min-height:66px;margin-block:12px 4px;padding:10px 12px;border:1px solid currentColor;border-radius:12px;background:transparent;color:inherit;font:inherit;font-size:13px;text-align:start;cursor:pointer}.pb-pg__single-extra[hidden]{display:none}.pb-pg__single-extra img{border-radius:6px;object-fit:cover}.pb-pg__single-extra strong{white-space:nowrap}.pb-pg__single-extra:focus-visible{outline:2px solid currentColor;outline-offset:3px}'
    + '[data-deal-block-id="bf55cb8f-7346-41c7-bd76-f73422bc2a2d"] .kaching-bundles__upsell__full-price{display:none!important}';
  document.head.appendChild(style);
  schedule();
})();

/* v16 2026-09-22: footmuff winter-set buttons (Footmuff / Snowsuit set / Double-zip set),
   page colour preselected, ?set=1|2 deep link. Runs only on footmuff pages with the Kaching winter set. */
(function () {
  'use strict';

  var root = document.querySelector('.pb-pg');
  var tabs = document.getElementById('pb-pg-tabs');
  var paneB = document.getElementById('pb-pg-pane-bundle');
  var catEl = document.querySelector('.pb-pg__cat');
  var titleEl = document.querySelector('.pb-pg__title');
  var variantSel = document.getElementById('pb-pg-variant');
  if (!root || !tabs || !paneB || !root.hasAttribute('data-pb-footmuff')) return;

  var winterText = {};
  try { winterText = JSON.parse(document.getElementById('pb-pg-vjson').textContent).bundleText || {}; } catch (_) {}

  var SET_RE = /snowsuit set/i;
  var built = false;
  var autoVals = {};
  var pending = null;

  function norm(s) { return (s || '').toLowerCase().replace(/grey/g, 'gray').replace(/[^a-z]/g, ''); }

  function pageColour() {
    var colour = root.getAttribute('data-pb-page-colour');
    if (colour) return colour.trim();
    var t = titleEl ? (titleEl.textContent || '').trim() : '';
    var m = t.match(/[–—-]\s*([^–—-]+)$/);
    return m ? m[1].trim() : '';
  }

  function matchValue(values, wanted) {
    var n = norm(wanted);
    if (!n) return null;
    var i;
    for (i = 0; i < values.length; i++) { if (norm(values[i]) === n) return values[i]; }
    for (i = 0; i < values.length; i++) { if (norm(values[i]) && norm(values[i]).indexOf(n) > -1) return values[i]; }
    for (i = 0; i < values.length; i++) { if (norm(values[i]) && n.indexOf(norm(values[i])) > -1) return values[i]; }
    return null;
  }

  function currencySymbol() {
    var el = document.getElementById('pb-pg-cta-price');
    var m = el ? (el.textContent || '').match(/[€$£¥]/) : null;
    return m ? m[0] : '';
  }

  function money(t) {
    var s = (t || '').replace(/\s+/g, ' ').trim();
    if (!s) return '';
    return /[€$£¥]/.test(s) ? s : currencySymbol() + s;
  }

  function allBars() { return Array.prototype.slice.call(document.querySelectorAll('#pb-pg-pane-bundle .kaching-bundles__bar')); }
  function barTitle(bar) { var t = bar.querySelector('.kaching-bundles__bar-title'); return t ? (t.textContent || '').trim() : ''; }
  function barId(bar) { var r = bar.querySelector('input[type="radio"]'); return r ? r.value : ''; }
  function setBars() { return allBars().filter(function (b) { return SET_RE.test(barTitle(b)); }); }
  function barById(id) { return allBars().filter(function (b) { return barId(b) === id; })[0] || null; }
  function shortName(title) { return /double/i.test(title) ? (winterText.double_zip_set || 'Double-zip set') : (winterText.snowsuit_set || 'Snowsuit set'); }

  function currentVariantParts() {
    if (window.PBPurchase) return window.PBPurchase.contextOptions();
    if (!variantSel || variantSel.selectedIndex < 0) return [];
    return (variantSel.options[variantSel.selectedIndex].text || '').split(' / ').map(function (s) { return s.trim(); });
  }

  function fixDefaultColour() {
    if (!variantSel) return;
    if (new URL(location.href).searchParams.has('variant')) return;
    var colour = pageColour();
    var opts = Array.prototype.slice.call(variantSel.options);
    var firstParts = opts.map(function (o) { return (o.text || '').split(' / ')[0].trim(); });
    var target = matchValue(firstParts, colour);
    if (!target) return;
    if (currentVariantParts()[0] === target) return;
    var rest = currentVariantParts().slice(1).join(' / ');
    var pick = opts.filter(function (o) { return !o.disabled && (o.text || '').split(' / ')[0].trim() === target; });
    var exact = pick.filter(function (o) { return (o.text || '').split(' / ').slice(1).join(' / ').trim() === rest; })[0];
    var opt = exact || pick[0];
    if (!opt) return;
    variantSel.value = opt.value;
    variantSel.dispatchEvent(new Event('change', { bubbles: true }));
    var thumbs = document.querySelectorAll('.pb-pg__vthumb');
    for (var i = 0; i < thumbs.length; i++) {
      var on = thumbs[i].getAttribute('data-pb-var') === opt.value;
      thumbs[i].classList.toggle('is-on', on);
      thumbs[i].setAttribute('aria-selected', on ? 'true' : 'false');
    }
  }

  function injectCss() {
    if (document.getElementById('pbfm-css')) return;
    var css = ''
      + '.pb-pg.pbfm-page #pb-pg-variant{color:#4A4B47!important;-webkit-text-fill-color:#4A4B47!important;opacity:1!important}'
      + '.pbfm #pb-pg-tabs{display:grid!important;grid-template-columns:repeat(var(--pbfm-n,3),minmax(0,1fr))!important;gap:4px!important;align-items:stretch!important}'
      + '.pbfm #pb-pg-tabs .pb-pg__tab{display:flex!important;flex-direction:column!important;align-items:center!important;justify-content:center!important;gap:2px!important;min-height:66px!important;padding:8px 4px!important;line-height:1.15!important;text-align:center!important;white-space:normal!important;width:auto!important;min-width:0!important}'
      + '.pbfm #pb-pg-tabs .pb-pg__tab-deal{display:none!important}'
      + '.pbfm .pbfm-seg__name{font-size:13.5px;letter-spacing:.01em}'
      + '.pbfm .pbfm-seg__price{font-size:12.5px;font-weight:500;color:var(--pb-price-sale,#7D3A36)}'
      + '.pbfm .pbfm-seg__gift{display:inline-block;margin-top:3px;padding:2px 7px;border-radius:999px;background:#F1F0DE;color:#85812A;font-size:10px;letter-spacing:.02em;white-space:nowrap}'
      + '.pbfm .pbfm-seg__gift--empty{visibility:hidden}'
      + '.pbfm--set #pb-pg-pane-bundle .kaching-bundles__bar:not(.kaching-bundles__bar--selected){display:none!important}'
      + '.pbfm--set #pb-pg-pane-bundle .kaching-bundles__bar--selected .kaching-bundles__bar-main{display:none!important}'
      + '.pbfm--set #pb-pg-pane-bundle .kaching-bundles__bar--selected{padding-left:14px!important;padding-right:14px!important}'
      + '.pbfm--set #pb-pg-pane-bundle .kaching-bundles__bar--selected .kaching-bundles__bar-wrapper{padding-left:0!important;padding-right:0!important}'
      + '.pbfm--set #pb-pg-pane-bundle .kaching-bundles__bundle-products{margin-left:0!important;margin-right:0!important;width:100%!important}'
      + '.pbfm--set #pb-pg-pane-bundle .pbk-summary{margin-left:0!important;margin-right:0!important;width:auto!important}'
      + '.pbfm--set #pb-pg-pane-bundle .kaching-bundles__bundle-products__product{width:100%!important;grid-template-columns:minmax(0,1fr)!important;grid-template-areas:"product" "price"!important;row-gap:8px!important;align-items:start!important}'
      + '.pbfm--set #pb-pg-pane-bundle .kaching-bundles__bundle-products__wrapper{grid-area:product!important;min-width:0!important;width:100%!important}'
      + '.pbfm--set #pb-pg-pane-bundle .kaching-bundles__bundle-products__content{flex:1 1 auto!important;min-width:0!important}'
      + '.pbfm--set #pb-pg-pane-bundle .kaching-bundles__bundle-products__content .kaching-bundles__bar-variant,.pbfm--set #pb-pg-pane-bundle .kaching-bundles__bundle-products__content .kaching-bundles__bar-variant__content,.pbfm--set #pb-pg-pane-bundle .kaching-bundles__bundle-products__content .kaching-bundles__bar-variant-main,.pbfm--set #pb-pg-pane-bundle .kaching-bundles__bundle-products__content .kaching-bundles__bar-variant-selects{width:100%!important;max-width:100%!important}'
      + '.pbfm--set #pb-pg-pane-bundle .kaching-bundles__bundle-products__pricing{grid-area:price!important;flex-direction:row!important;flex-wrap:wrap!important;align-items:center!important;justify-content:flex-start!important;gap:6px!important;width:auto!important;min-width:0!important;padding-left:var(--pbfm-indent,62px)!important}'
      + '#MainContent .pbfm .pbk-free-badge{display:inline-flex!important;align-items:center!important;gap:4px!important;width:auto!important;height:auto!important;padding:3px 9px!important;border-radius:999px!important;background:#6F6C20!important;color:#fff!important;font-size:10.5px!important;line-height:1.3!important;letter-spacing:.08em!important;white-space:nowrap!important;overflow:visible!important}'
      + '#MainContent .pbfm .pbk-free-badge,#MainContent .pbfm .pbk-free-badge *{color:#fff!important}'
      + '#MainContent .pbfm .pbk-free-badge svg{stroke:#fff!important;width:11px!important;height:11px!important}'
      + '#MainContent .pbfm .pbk-free-value{white-space:nowrap!important}'
      + '.pbfm--set #pb-pg-pane-bundle .kaching-bundles__bar-variant-main::after{display:none!important;content:none!important}'
      + '.pbfm--set #pb-pg-pane-bundle .kaching-bundles__bar-variant-selects{display:flex!important;flex-direction:row!important;flex-wrap:nowrap!important;gap:8px!important}'
      + '.pbfm--set #pb-pg-pane-bundle .kaching-bundles__bar-variant-select{flex:1 1 0!important;min-width:0!important;-webkit-appearance:none!important;appearance:none!important;padding-right:28px!important;background-image:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'10\' height=\'6\' viewBox=\'0 0 10 6\'%3E%3Cpath d=\'M1 1l4 4 4-4\' fill=\'none\' stroke=\'%238C8880\' stroke-width=\'1.4\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/%3E%3C/svg%3E")!important;background-repeat:no-repeat!important;background-position:right 11px center!important;background-size:10px 6px!important}'
      + '@media (min-width:990px){.pbfm .pbfm-seg__name{font-size:14.5px}.pbfm .pbfm-seg__price{font-size:13.5px}}';
    var st = document.createElement('style');
    st.id = 'pbfm-css';
    st.textContent = css;
    document.head.appendChild(st);
  }

  function segHtml(name, price, gift) {
    return '<span class="pbfm-seg__name">' + name + '</span>'
      + '<span class="pbfm-seg__price">' + price + '</span>'
      + '<span class="pbfm-seg__gift' + (gift ? '' : ' pbfm-seg__gift--empty') + '">' + (gift || ' ') + '</span>';
  }

  function footmuffPrice() {
    var el = document.getElementById('pb-pg-cta-price');
    if (el) {
      var clone = el.cloneNode(true);
      var s = clone.querySelectorAll('s,del');
      for (var i = 0; i < s.length; i++) s[i].remove();
      var t = (clone.textContent || '').trim();
      if (t) return money(t);
    }
    var solo = allBars().filter(function (b) { return !SET_RE.test(barTitle(b)); })[0];
    var p = solo ? solo.querySelector('.kaching-bundles__bar-price') : null;
    return p ? money(p.textContent) : '';
  }

  function refreshLabels() {
    var prodTab = tabs.querySelector('[data-pbfm="product"]');
    if (prodTab) {
      var html = segHtml(winterText.footmuff || 'Footmuff', footmuffPrice(), '');
      if (prodTab.dataset.pbfmHtml !== html) { prodTab.innerHTML = html; prodTab.dataset.pbfmHtml = html; }
    }
    var setTabs = tabs.querySelectorAll('[data-pbfm-bar]');
    for (var i = 0; i < setTabs.length; i++) {
      var bar = barById(setTabs[i].getAttribute('data-pbfm-bar'));
      if (!bar) continue;
      var p = bar.querySelector('.kaching-bundles__bar-price');
      var lab = bar.querySelector('.kaching-bundles__bar-label');
      var h = segHtml(shortName(barTitle(bar)), p ? money(p.textContent) : '', winterText.free_gift || 'Free gift');
      if (setTabs[i].dataset.pbfmHtml !== h) { setTabs[i].innerHTML = h; setTabs[i].dataset.pbfmHtml = h; }
    }
  }

  function build() {
    if (built || tabs.hidden) return false;
    var sets = setBars();
    var prodTab = tabs.querySelector('[data-pb-pane="product"]');
    var bundleTab = tabs.querySelector('[data-pb-pane="bundle"]');
    if (!sets.length || !prodTab || !bundleTab) return false;
    built = true;
    injectCss();
    root.classList.add('pbfm');
    tabs.style.setProperty('--pbfm-n', String(sets.length + 1));
    prodTab.setAttribute('data-pbfm', 'product');
    sets.forEach(function (bar, i) {
      var btn = i === 0 ? bundleTab : document.createElement('button');
      if (i > 0) {
        btn.type = 'button';
        btn.className = 'pb-pg__tab';
        btn.setAttribute('data-pb-pane', 'bundle');
        btn.setAttribute('aria-controls', 'pb-pg-pane-bundle');
        tabs.appendChild(btn);
      }
      btn.setAttribute('data-pbfm-bar', barId(bar));
      btn.setAttribute('aria-pressed', btn.classList.contains('is-on') ? 'true' : 'false');
    });
    refreshLabels();
    var params = new URLSearchParams(location.search);
    var bundleParam = params.get('pb_bundle');
    var forceProduct = bundleParam === '0' || (bundleParam === null && params.get('pb_tab') === 'product');
    var want = params.get('set');
    var chosen = null;
    if (!forceProduct && /^(1|2)$/.test(want || '')) {
      chosen = sets[parseInt(want, 10) - 1];
    } else if (!forceProduct && (bundleParam === '1' || tabs.getAttribute('data-pb-default-pane') === 'bundle')) {
      chosen = sets.filter(function (bar) { return bar.classList.contains('kaching-bundles__bar--selected'); })[0] || sets[0];
    }
    if (chosen) {
      var choices = tabs.querySelectorAll('[data-pbfm-bar]');
      for (var j = 0; j < choices.length; j++) {
        if (choices[j].getAttribute('data-pbfm-bar') === barId(chosen)) { choices[j].click(); break; }
      }
    } else if (forceProduct) {
      prodTab.click();
    }
    return true;
  }

  function polishCopy() {
    var items = paneB.querySelectorAll('.pbk-sum-items');
    for (var i = 0; i < items.length; i++) {
      var t = items[i].textContent || '';
      var n = t.replace(/\s+[—–-]\s+gift\s+\(free gift\)/i, ' (free gift)');
      if (n !== t) items[i].textContent = n;
    }
    var prods = paneB.querySelectorAll('.kaching-bundles__bundle-products__product');
    for (var k = 0; k < prods.length; k++) {
      var content = prods[k].querySelector('.kaching-bundles__bundle-products__content');
      if (!content) continue;
      var off = Math.round(content.getBoundingClientRect().left - prods[k].getBoundingClientRect().left);
      if (off > 0 && off < 200 && prods[k].style.getPropertyValue('--pbfm-indent') !== off + 'px') prods[k].style.setProperty('--pbfm-indent', off + 'px');
    }
    var vals = paneB.querySelectorAll('.pbk-free-value');
    for (var j = 0; j < vals.length; j++) {
      var v = vals[j].textContent || '';
      var m = v.match(/\(?\s*([€$£]?\s*[\d.,]+)\s*VALUE!?\s*\)?/i);
      if (m) {
        var nv = 'Worth ' + money(m[1]);
        if (nv !== v) vals[j].textContent = nv;
      }
    }
  }

  function selectBar(id) {
    var bar = barById(id);
    if (!bar || bar.classList.contains('kaching-bundles__bar--selected')) return;
    var main = bar.querySelector('.kaching-bundles__bar-main') || bar.querySelector('label') || bar;
    main.click();
  }

  function presetFootmuffSlot() {
    if (!root.classList.contains('pbfm--set')) return;
    var bar = document.querySelector('#pb-pg-pane-bundle .kaching-bundles__bar--selected');
    if (!bar) return;
    var slot = bar.querySelector('.kaching-bundles__bundle-products__product');
    if (!slot) return;
    var want = currentVariantParts();
    if (!want.length) return;
    var sels = slot.querySelectorAll('select');
    for (var i = 0; i < sels.length && i < want.length; i++) {
      var s = sels[i];
      var key = barId(bar) + ':' + i;
      var values = Array.prototype.slice.call(s.options).filter(function (o) { return o.value && !o.disabled; }).map(function (o) { return o.value; });
      var target = matchValue(values, want[i]);
      if (!target) continue;
      var untouched = root.hasAttribute('data-pb-colour-sync') || !s.value || s.value === autoVals[key];
      if (untouched && s.value !== target) {
        s.value = target;
        autoVals[key] = target;
        s.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (!s.value) {
        autoVals[key] = target;
      }
    }
  }

  function markActive() {
    var active = tabs.querySelector('.pb-pg__tab.is-on');
    var isSet = !!(active && active.hasAttribute('data-pbfm-bar'));
    root.classList.toggle('pbfm--set', isSet);
    var all = tabs.querySelectorAll('.pb-pg__tab');
    for (var i = 0; i < all.length; i++) all[i].setAttribute('aria-pressed', all[i].classList.contains('is-on') ? 'true' : 'false');
    return active;
  }

  tabs.addEventListener('click', function (e) {
    if (!built) return;
    var t = e.target.closest('.pb-pg__tab');
    if (!t) return;
    setTimeout(function () {
      markActive();
      var id = t.getAttribute('data-pbfm-bar');
      if (id) {
        selectBar(id);
        setTimeout(presetFootmuffSlot, 250);
        setTimeout(presetFootmuffSlot, 900);
      }
    }, 0);
  });

  function tick() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      if (!built) build();
      if (!built) return;
      refreshLabels();
      presetFootmuffSlot();
      polishCopy();
    }, 150);
  }

  root.classList.add('pbfm-page');
  injectCss();
  fixDefaultColour();
  new MutationObserver(tick).observe(paneB, { childList: true, subtree: true });
  new MutationObserver(tick).observe(tabs, { attributes: true, attributeFilter: ['hidden'] });
  if (variantSel) variantSel.addEventListener('change', tick);
  [600, 1500, 3000, 5000, 8000, 12000].forEach(function (ms) { setTimeout(tick, ms); });
})();

/* v16: readable colour/size select on phones for all products (glass-fix CSS painted it white-on-white). */
(function () {
  'use strict';
  if (document.getElementById('pb-select-ink-css')) return;
  var st = document.createElement('style');
  st.id = 'pb-select-ink-css';
  st.textContent = '@media (max-width:989.98px){.pb-pg.pb-pg--dark #pb-pg-variant{color:#4A4B47!important;-webkit-text-fill-color:#4A4B47!important;opacity:1!important}}';
  (document.head || document.documentElement).appendChild(st);
})();



/* Keep fixed-bundle choices across a language form navigation, once per tab. */
(function () {
  'use strict';
  var wrap = document.getElementById('pb-pg-buywrap');
  var tabs = document.getElementById('pb-pg-tabs');
  if (!wrap || !tabs) return;
  var storageKey = 'pb:bundle-language:v1';
  var script = document.querySelector('script[src*="/assets/pb-pdp-tabs.js"]');
  var theme = script ? new URL(script.src, location.href).pathname : '';
  var productPath = location.pathname.match(/\/products\/[^/]+/);
  if (!theme || !productPath) return;
  var product = productPath[0];
  var pending = null;
  var timer = null;
  var deadline = 0;
  var changes = 0;
  var stable = 0;

  function slots(bar) {
    return Array.prototype.slice.call(bar.querySelectorAll('.kaching-bundles__bundle-products__product'));
  }

  function slotProduct(slot, index) {
    var link = slot.querySelector('a[href*="/products/"]');
    var match = link && new URL(link.href, location.href).pathname.match(/\/products\/[^/]+/);
    return match ? match[0] : index === 0 ? product : '';
  }

  // Capture before the native localization component calls form.submit().
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || input.tagName !== 'SELECT' || input.name !== 'language_code') return;
    var form = input.form;
    if (!form || !/\/localization\/?$/.test(new URL(form.action, location.href).pathname)) return;
    try { sessionStorage.removeItem(storageKey); } catch (_) { return; }
    var active = tabs.querySelector('.pb-pg__tab.is-on');
    var bar = wrap.querySelector('.kaching-bundles__bar--selected');
    if (!active || active.getAttribute('data-pb-pane') !== 'bundle' || !bar) return;
    if (!input.value || input.value.toLowerCase() === document.documentElement.lang.toLowerCase()) return;
    var items = slots(bar).map(function (slot, index) {
      return {
        product: slotProduct(slot, index),
        options: Array.prototype.slice.call(slot.querySelectorAll('.kaching-bundles__bar-variant-select')).map(function (select) {
          return { name: select.getAttribute('data-name'), value: select.value };
        })
      };
    });
    if (!items.length || items.some(function (item) { return !item.product; })) return;
    if (!items.some(function (item) { return item.options.length; })) return;
    var destination = new URL(location.href);
    var variant = document.querySelector('#pb-pg-form input[name="id"]');
    if (variant && variant.value) destination.searchParams.set('variant', variant.value);
    destination.searchParams.set('pb_bundle', '1');
    var country = form.querySelector('[name="country_code"]');
    var record = {
      theme: theme, product: product, language: input.value.toLowerCase(),
      country: country ? country.value : '',
      variant: destination.searchParams.get('variant'),
      bar: bar.getAttribute('data-deal-bar-id'), items: items, expires: Date.now() + 60000
    };
    try { sessionStorage.setItem(storageKey, JSON.stringify(record)); } catch (_) { return; }
    var returnTo = form.querySelector('[name="return_to"]');
    if (returnTo) returnTo.value = destination.pathname + destination.search + destination.hash;
  }, true);

  try {
    pending = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
    sessionStorage.removeItem(storageKey);
  } catch (_) { return; }
  if (!pending || pending.theme !== theme || pending.product !== product || pending.expires < Date.now()) return;
  if (pending.language !== document.documentElement.lang.toLowerCase()) return;
  if (pending.variant !== new URL(location.href).searchParams.get('variant')) return;
  var country = document.querySelector('form[action*="/localization"] [name="country_code"]');
  if (pending.country && (!country || pending.country !== country.value)) return;
  if (!Array.isArray(pending.items) || !pending.items.length || !pending.bar) return;

  function finish(result) {
    pending = null;
    clearTimeout(timer);
    wrap.setAttribute('data-pb-locale-restore', result);
    wrap.removeEventListener('pointerdown', cancel, true);
    wrap.removeEventListener('keydown', cancel, true);
    tabs.removeEventListener('click', cancel, true);
  }

  function cancel(event) {
    if (event.isTrusted) finish('cancelled');
  }

  function restore() {
    if (!pending) return;
    if (Date.now() > deadline || changes > 30) { finish('timeout'); return; }
    var bars = Array.prototype.slice.call(wrap.querySelectorAll('.kaching-bundles__bar'));
    var bar = bars.filter(function (item) { return item.getAttribute('data-deal-bar-id') === pending.bar; })[0];
    if (bar && !tabs.hidden) {
      if (!bar.classList.contains('kaching-bundles__bar--selected')) {
        var heading = bar.querySelector('.kaching-bundles__bar-main');
        if (heading) { changes += 1; heading.click(); }
      } else {
        var current = slots(bar);
        if (current.length === pending.items.length) {
          var changed = false;
          for (var i = 0; i < current.length && !changed; i++) {
            var item = pending.items[i];
            if (slotProduct(current[i], i) !== item.product) { finish('unavailable'); return; }
            var selects = current[i].querySelectorAll('.kaching-bundles__bar-variant-select');
            if (selects.length !== item.options.length) { stable = 0; break; }
            for (var j = 0; j < selects.length; j++) {
              var select = selects[j];
              var wanted = item.options[j];
              if (select.getAttribute('data-name') !== wanted.name) { finish('unavailable'); return; }
              var available = Array.prototype.some.call(select.options, function (option) {
                return option.value === wanted.value && !option.disabled;
              });
              if (!available) { finish('unavailable'); return; }
              if (select.value !== wanted.value) {
                changes += 1;
                select.value = wanted.value;
                select.dispatchEvent(new Event('change', { bubbles: true }));
                changed = true;
                break;
              }
            }
          }
          if (!changed && i === current.length) {
            stable += 1;
            if (stable >= 3) { finish('complete'); return; }
          } else stable = 0;
        }
      }
    }
    timer = setTimeout(restore, 150);
  }

  wrap.setAttribute('data-pb-locale-restore', 'pending');
  wrap.addEventListener('pointerdown', cancel, true);
  wrap.addEventListener('keydown', cancel, true);
  tabs.addEventListener('click', cancel, true);
  window.addEventListener('pagehide', function () { finish('cancelled'); }, { once: true });
  deadline = Date.now() + 15000;
  restore();
})();
